import * as React from 'react';
import { caption1Bold } from '@westwing/ui-kit/typography';
import styled from 'styled-components';
import useCountUp, { UseCountUpOptions } from '@ids/hooks/useCountUp';
import { StyledBenefits } from '@ids/pages/landing/blocks/PriceTiers/Benefits';
import { useInView } from '@ids/hooks';
import { SerializedCTAPush } from '@ids/types/now-api';

export const StyledCTAPush = styled.p`
    ${caption1Bold}
    color: var(--color, #FFF);
    text-align: center;
    margin: 10px 0;
    span {
        font-size: 15px;
        width: calc(var(--char-count) * 1ch);
        display: inline-block;
        font-variant-numeric: tabular-nums;
    }

    & + ${StyledBenefits} {
        margin-top: -8px;
    }
`;

const getSentence = (sentence: string, target: number) => {
    return sentence.replace('ROOMS_SOLD', `<span style="--char-count: ${target.toString().length}">${target}</span>`);
};

interface CTAPushProps extends SerializedCTAPush {
    color?: string;
    shouldAnimate?: boolean;
}

const CTAPush = ({
    completeSentence,
    roomsSold,
    animationOptions,
    color = '#FFF',
    shouldAnimate = true,
}: CTAPushProps) => {
    const ctaPushRef = React.useRef<HTMLDivElement>(null);
    const isCTAPushInView = useInView<HTMLDivElement>({
        containerRef: ctaPushRef,
    });

    const controls: UseCountUpOptions = {
        initialValue: animationOptions?.initialValue,
        step: animationOptions?.step ?? 3,
        speed: animationOptions?.speed ?? 2,
        trigger: isCTAPushInView,
    };

    const countUpNumber = useCountUp(roomsSold ?? 0, controls);

    return (
        <StyledCTAPush
            ref={ctaPushRef}
            style={{ '--color': color } as React.CSSProperties}
            data-testid="cta-push"
            dangerouslySetInnerHTML={{
                __html: getSentence(completeSentence, shouldAnimate ? countUpNumber : roomsSold),
            }}
        />
    );
};

const EmptyCTAPush = () => (
    <StyledCTAPush data-testid="cta-push">
        <span>&nbsp;</span>
    </StyledCTAPush>
);

CTAPush.Empty = EmptyCTAPush;

export { CTAPush as default, getSentence as getCTAPushSentence };
